/**
 * @sw-package fundamentals@after-sales
 * @private
 */
Shopware.Component.override('sw-dashboard-index', () => import('./sw-dashboard-index'));
